exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1yWnx{min-height:inherit}\n", ""]);

// Exports
exports.locals = {
	"pageStretchContentVertically": "_1yWnx"
};